export const LOAD_CART = 'LOAD_CART';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const CHANGE_PRODUCT_QUANTITY = 'CHANGE_PRODUCT_QUANTITY';
export const UPDATE_CART = 'UPDATE_CART';
export const SHOW_CART = 'SHOW_CART';
export const UPDATE_TOTAL ='UPDATE_TOTAL';
export const COUPON_UPDATE = 'COUPON_UPDATE';

